export default __webpack_public_path__ + "79286ece32678a4b759a2533cef514b6.png";